var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParkingComfortModeActiveSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.7167969,4.0585938c-4.7607422,3.25-11.1953125,8.7460938-16.7919922,14.3427734 c-2.3826904,2.3826904-2.5578003,6.1532593-0.5634766,8.8232422l-3.0683594,3.0683594l1.4140625,1.4140625l3.0684204-3.0684204 c1.2201538,0.911438,2.666748,1.3760376,4.109314,1.3760376c1.7158203,0,3.4199219-0.6455078,4.7138672-1.9394531 c5.1728516-5.1728516,11.3388462-12.3916016,14.3427734-16.7919922c3.8164062-5.5878906,4.9208984-9.0556641,3.3759766-10.6005859 C29.7705078-0.8642578,26.3037109,0.2431641,20.7167969,4.0585938z M26.2890625,10.15625 c-2.9433594,4.3115234-9.0068359,11.4072266-14.1044922,16.5048828c-1.5736084,1.5736084-4.1175537,1.7435303-5.9741211,0.5424805 l11.496582-11.496582l-1.4140625-1.4140625L4.7963257,25.7896118c-1.2015991-1.8572998-1.0303345-4.4013062,0.5425415-5.9741821 C10.8544922,14.3007812,17.1787109,8.8955078,21.84375,5.7109375c4.4775391-3.0576172,6.7314453-3.7216797,7.6220703-3.7216797 c0.2363281,0,0.3769531,0.046875,0.4375,0.1074219C30.1943359,2.3876953,30.15625,4.4941406,26.2890625,10.15625z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingComfortModeActiveSmall);
export default __webpack_public_path__ + "static/media/parking-comfort-mode-active--small.db2cfe58c724aca36c0aa5651b1e50df.svg";
export { ForwardRef as ReactComponent };